import type { JobSeekerProofFile } from '../../../../../index';
import getHelper from '../../../services/getHelper';

export default getHelper<JobSeekerProofFile>('/job-seeker-proof-files/:id');
